import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Mail } from 'lucide-react';
const paragraphs = ['This domain was purchased simply to offer a web page for a business — a café — to help them grow online.', 'We’re web developers, not in the business of opening cafés or extorting anyone. This young man claimed we were extorting him.', 'We simply offered him a business web page for $400, including the domain. After that, he would own it all. It wasn’t about charging him ongoing fees.', 'But he jumped ahead, looking for arguments. He could have just said, “I’m not interested yet, but I’d like to own the domain for the future,” and I would have given it to him for free. But he didn’t listen.', 'Opening a business is a big milestone, and there are many steps to take. A web page is one of those essential things you really want, especially in 2026.', 'Sometimes people trademark a name but forget to secure the domain. It’s a simple oversight that can happen to anyone. That’s where we come in: we help businesses reach their full potential by providing the domain and a professional web page — no strings attached.', 'We’re here to support growth, not to create disputes. Once the page is delivered, the business owns it all. Our main goal is to help businesses thrive online.', 'When you open a business, arguing and looking for “beef” is not something you really want to do. That alone says a lot about the age of the person and how they’ve matured — or have not matured.'];
export function Statement() {
  return <main className="relative z-10 min-h-screen w-full flex flex-col items-center justify-center px-5 py-16 md:py-20" data-id="element-3">
      <motion.article initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="w-full max-w-2xl bg-paper/95 backdrop-blur-md rounded-3xl border border-white/60 shadow-2xl shadow-[#0C302E]/20 px-6 py-10 md:px-12 md:py-14" data-id="element-4">
        <div className="flex items-center gap-4 mb-10" data-id="element-5">
          <span className="text-xs font-sans tracking-[0.25em] uppercase text-stone" data-id="element-6">
            A Note From the Developers
          </span>
          <div className="h-px flex-grow bg-line" data-id="element-7" />
        </div>

        <h1 className="font-serif text-3xl md:text-4xl text-ink leading-tight mb-8" data-id="element-8">
          Setting the record straight
        </h1>

        <div className="space-y-6" data-id="element-9">
          {paragraphs.map((text, i) => <motion.p key={i} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: 0.2 + i * 0.15
        }} className="font-sans text-base md:text-lg leading-relaxed text-ink/85" data-id="element-10">
              {text}
            </motion.p>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2 + paragraphs.length * 0.15
      }} className="mt-12 pt-8 border-t border-line flex items-center gap-3" data-id="element-11">
          <span className="inline-block w-6 h-px bg-accent" data-id="element-12" />
          <p className="font-serif italic text-stone text-sm md:text-base" data-id="element-13">
            With respect, the development team.
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4 + paragraphs.length * 0.15
      }} className="mt-10 font-serif text-lg md:text-xl text-accent leading-snug" data-id="element-14">
          Ser joven y comer mieda no es fácil. Eso sí, de verdad esta{' '}
          <span className="font-semibold tracking-wide" data-id="element-15">DEPINGAAA</span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.55 + paragraphs.length * 0.15
      }} className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8" data-id="element-16">
          <motion.a href="https://www.instagram.com/salesupmarketing?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram" whileHover={{
          scale: 1.04
        }} className="inline-flex items-center gap-2 text-stone hover:text-accent transition-colors" data-id="element-17">
            <Instagram size={22} strokeWidth={1.75} data-id="element-18" />
            <span className="font-sans text-sm tracking-wide" data-id="element-19">Follow us</span>
          </motion.a>

          <motion.a href="mailto:jose@teachmejose.com" aria-label="Email Jose at jose@teachmejose.com" whileHover={{
          scale: 1.04
        }} className="inline-flex items-center gap-2 text-stone hover:text-accent transition-colors" data-id="element-20">
            <Mail size={22} strokeWidth={1.75} data-id="element-21" />
            <span className="font-sans text-sm tracking-wide" data-id="element-22">
              or email me — jose@teachmejose.com
            </span>
          </motion.a>
        </motion.div>
      </motion.article>
    </main>;
}